import { FC } from 'react';

import { EmployeePermission } from 'src/api/permissions';

export enum RoutePath {
  Main = '',
  DeskBooking = 'deskBooking',
  RoomBooking = 'roomBooking',
  Parking = 'parking',
  Administrator = 'administrator',
  Spaces = 'spaces',
  MyBookings = 'myBookings',
  Search = 'search',
  // Feedback = 'feedback',
}

export interface TabItem {
  label: string;
  path: RoutePath;
  permission: EmployeePermission;
}

export interface RouteInfo {
  path: RoutePath;
  Element: FC;
  permission?: EmployeePermission;
}
